<template>
  <section class="container-full-1 bg-grey-50">
    <div class="page-header">
      <div>
        <h2 class="secondary-font font-semibold" style="margin: 0;">Informations personnelles</h2>
        <p class="text-sm text-grey-600" style="margin: 0.25rem 0 0;">Consultez et modifiez vos informations personnelles.</p>
      </div>
    </div>

    <div class="widget edit-card">
      <form @submit.prevent="handleSaveInfo">
        <div class="form-grid">
          <div>
            <div class="form-field-floating lg reactive active">
              <input id="nom" type="text" class="form-input" v-model="formData.nom" placeholder="" />
              <label for="nom">Nom <b class="color-danger">*</b></label>
            </div>
          </div>
          <div>
            <div class="form-field-floating lg reactive active">
              <input id="prenom" type="text" class="form-input" v-model="formData.prenom" placeholder="" />
              <label for="prenom">Prénom <b class="color-danger">*</b></label>
            </div>
          </div>
        </div>

        <div class="form-grid">
          <div>
            <div class="form-field-floating lg reactive active">
              <input id="email" type="email" class="form-input" v-model="formData.email" placeholder="" />
              <label for="email">Adresse email <b class="color-danger">*</b></label>
            </div>
          </div>
          <div>
            <custom-phone-input v-model="formData.telephone" id="telephone" />
          </div>
        </div>

        <div class="form-field-floating lg reactive active">
          <input id="fonction" type="text" class="form-input" v-model="formData.fonction" placeholder="" />
          <label for="fonction">Fonction</label>
        </div>

        <div v-if="success" class="alert alert-success mt-4">{{ success }}</div>
        <div v-if="errorMessage" class="alert alert-error mt-4">{{ errorMessage }}</div>

        <div class="form-actions">
          <button type="submit" class="btn lg" :disabled="loading">
            <img src="/public/icons/icon-info-perso.svg" class="btn-icon icon-white" alt="" />
            <span v-if="!loading">Enregistrer les modifications</span>
            <span v-else>Enregistrement...</span>
          </button>
        </div>
      </form>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue'
import authService from '@/services/authService'
import CustomPhoneInput from '@/components/CustomPhoneInput.vue'

export default defineComponent({
  name: 'InformationsPersonnelles',
  components: { CustomPhoneInput },
  setup() {
    const formData = ref({
      nom: '',
      prenom: '',
      email: '',
      telephone: '',
      fonction: ''
    })
    const success = ref('')
    const errorMessage = ref('')
    const loading = ref(false)

    function applyUserToForm(user: any) {
      formData.value = {
        nom: user?.nom || '',
        prenom: user?.prenom || '',
        email: user?.email || '',
        telephone: user?.telephone || '',
        fonction: user?.fonction || ''
      }
    }

    onMounted(async () => {
      const user = authService.getCurrentUser()
      if (user) applyUserToForm(user)

      try {
        const response = await authService.getProfile()
        if (response.status === 0 && response.data) {
          applyUserToForm(response.data)
        }
      } catch (e) {
        // silencieux : on garde les données locales si l'appel échoue
      }
    })

    const handleSaveInfo = async () => {
      success.value = ''
      errorMessage.value = ''
      loading.value = true
      try {
        const response = await authService.updateProfile(formData.value)
        if (response.status === 0) {
          success.value = response.message || 'Vos informations ont été mises à jour avec succès !'
          setTimeout(() => { success.value = '' }, 3000)
        } else {
          errorMessage.value = response.message || 'Une erreur est survenue lors de la mise à jour.'
        }
      } catch (e: any) {
        errorMessage.value = e?.response?.data?.message || e?.message || 'Une erreur est survenue lors de la mise à jour.'
      } finally {
        loading.value = false
      }
    }

    return {
      formData,
      success,
      errorMessage,
      loading,
      handleSaveInfo
    }
  }
})
</script>

<style scoped>
.page-header {
  margin-bottom: 1.5rem;
  padding: 0 0.25rem;
}

.edit-card {
  padding: 2rem;
  max-width: 900px;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
  margin-bottom: 0.75rem;
}

@media (max-width: 700px) {
  .form-grid {
    grid-template-columns: 1fr;
  }
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 1.75rem;
  padding-top: 1.25rem;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}

.alert-success {
  padding: 1rem 1.25rem;
  border-radius: 12px;
  font-size: 0.9rem;
  background: rgba(0, 208, 180, 0.1);
  color: rgb(0, 150, 130);
  border: 1px solid rgba(0, 208, 180, 0.3);
}

.alert-error {
  padding: 1rem 1.25rem;
  border-radius: 12px;
  font-size: 0.9rem;
  background: rgba(220, 53, 69, 0.08);
  color: rgb(180, 30, 50);
  border: 1px solid rgba(220, 53, 69, 0.25);
}
</style>
